import instance from '@apis/instance';
import { ProjectPaymentMethodResponse } from '@models/project/projectPrepaidMethod';

class PaymentMethodApi {
    static getPaymentMethods(): Promise<ProjectPaymentMethodResponse> {
        return instance.get('/v0/project/payment-methods');
    }
}

export default PaymentMethodApi;
